export default __webpack_public_path__ + "static/media/oval.00b419c6.svg";